export default "__VITE_ASSET__CaBQCSmR__"